export default __webpack_public_path__ + "static/media/logo-simple.ee6ebc0e.png";